// import Vue from './composition.ts'
import '@/plugins/index.js';
import Vue from 'vue';
import Router from 'vue-router';

import App from '@/App.vue';
import { registerElImageOverride, registerFileUrlGuard } from '@/permission.js';
import router from '@/router/router.js';
import store from '@/store';
import { buildAuthToken, serializeBody, isEncryptableBody } from '@/http/authCrypto';
import { replaceRelayCosfile, replaceFileUrlPrefix } from '@/utils/urlTransform';
import VConsole from 'vconsole';
import '@/styles/index.less';
import '@/styles/transition.css';

// 组件注册

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '@/styles/index.less';

// 适配
import 'amfe-flexible';
import vueEsign from 'vue-esign';
import VueCompositionApi from '@vue/composition-api';
Vue.use(vueEsign);
Vue.use(ElementUI, { size: 'small' });
registerElImageOverride();
// van-image 不再单独覆盖，统一由下方 registerFileUrlGuard 在 DOM 层拦截
Vue.use(VueCompositionApi);
// FastClick.attach(document.body);
// 或者使用配置参数来初始化，详情见文档
if (process.env.NODE_ENV === 'development') {
  const vConsole = new VConsole({ theme: 'dark' });
}

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config ] = args;
  config = config || {};
  config.headers = {
    ...config.headers,
    userid: sessionStorage.getItem('userid') || ''
  }

  // 与 request.js 拦截器保持同一开关判断（勿单独改动）
  const isDcopsTokenOn = String(store.getters.getConfigItem('isDcopsToken')) === '1';
  if (isDcopsTokenOn && !config.headers.token) {
    try {
      const body = config.body;
      let plaintext;
      if (body == null) {
        plaintext = ''; // 无 body（GET 等），明文为空串
      } else if (typeof body === 'string') {
        plaintext = body; // fetch 的 body 通常已是字符串，它即最终发送字节
      } else if (isEncryptableBody(body)) {
        // 对象等：先序列化为字符串再发送，保证 token 与 body 字节一致
        plaintext = serializeBody(body);
        config.body = plaintext;
      } else {
        // FormData/Blob/URLSearchParams 无法复现最终字节，跳过加 token
        plaintext = null;
      }
      if (plaintext !== null) {
        config.headers.token = await buildAuthToken(plaintext);
      }
    } catch (e) {
      console.error('[main fetch] 生成加密 token 失败：', e);
    }
  }

  // request interceptor ends
  const response = await originalFetch(resource, config);
  // response interceptor here
  return response;
};

// 只需修改xxxxx值，其余无需修改
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'TaskTypeList') {
    // 创建一个StorageEvent事件
    const newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, newVal);
  }
};

// 扩展全局方法
// 注意：方法名沿用 $processImageUrl，但实际处理的是所有文件链接（图片 + 非图片文件）。
// 仅在渲染层使用，不参与上传、提交等请求参数。
Vue.prototype.$processImageUrl = function(url) {
  if (!url || typeof url !== 'string') return url;

  // 1) 域名 + 路径前缀统一映射（规则表维护在 utils/urlTransform.js）
  //    dcops.woa.com / dcops.idc.tencent.com        -> otob.dcops.qq.com
  //    dcops.test.woa.com / dcops.test.tencent.com  -> test.otob.dcops.qq.com
  //    必须放在路径补全之前：否则 /relay/cosfile 会被提前补成 /file-center/relay/cosfile，
  //    规则表里的 from 就再也匹配不上了
  const target = replaceFileUrlPrefix(url, 'processImageUrl');

  // 2) 渲染链接路径补全：/relay/cosfile -> /file-center/relay/cosfile
  //    规则表产出的地址已含 /file-center，此处会按 SKIP_PREFIXES 跳过，不会重复叠加
  return replaceRelayCosfile(target, 'processImageUrl');
};

// 统一拦截 window.open，先处理 URL 前缀再打开新窗口
const originOpen = window.open;
window.open = function (...args) {
  if (args.length > 0 && typeof args[0] === 'string') {
    args[0] = Vue.prototype.$processImageUrl(args[0]);
  }
  return originOpen.apply(window, args);
};

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

// 拦截所有文件链接的渲染赋值（图片 src、iframe src、下载链接 href、video poster 等）：
// van-uploader / ImagePreview 内部直接 import 组件，不经过全局组件注册，
// 只有从 DOM 层拦截才能覆盖到这些缩略图与非图片文件预览/下载地址
registerFileUrlGuard();

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
